import React from "react";
import './Error.css';




const Error=()=> {
return(
    <div className="error-content">
        <h1> 4<strong>0</strong>4 </h1>
        <p> Oops! Page not found </p>
    </div>
)
}

export default Error;


// WEBPACK FOOTER //
// ./src/Component/Error.js